import * as _util2 from "util";

var _util = "default" in _util2 ? _util2.default : _util2;

import _warning_messages from "./warning_messages.json";
var exports = {};
var util = _util;
var messages = _warning_messages;

exports = function () {
  var args = Array.prototype.slice.call(arguments, 0);
  var warningName = args.shift();

  if (warningName === "typo") {
    return makeTypoWarning.apply(null, args);
  } else {
    var msgTemplate = messages[warningName] ? messages[warningName] : warningName + ": '%s'";
    args.unshift(msgTemplate);
    return util.format.apply(null, args);
  }
};

function makeTypoWarning(providedName, probableName, field) {
  if (field) {
    providedName = field + "['" + providedName + "']";
    probableName = field + "['" + probableName + "']";
  }

  return util.format(messages.typo, providedName, probableName);
}

export default exports;